// extracted by mini-css-extract-plugin
module.exports = {"nav":"RootAdmin_nav__1DWCZ","viewLayout":"RootAdmin_viewLayout__26YHC"};